module.exports = __webpack_public_path__ + "static/scale-model-of-prospect-terrace-in-providence-rhode-island-54d1844a6c018c8ab20bf7fca2f06657.png";